import React, {useEffect, useState} from 'react';
import TableComponent from '../../../components/table';
import PaginationComponent from '../../../components/pagination';
import Api from "../../../services/api";
import {toast} from "react-toastify";
import {Modal,Button} from 'react-bootstrap';
import LoadingComponent from "../../../components/loading";

function CustomDashboard() {
    const [searchTerm, setSearchTerm] = useState(false);  // Lưu nội dung input
    const [searchValue, setSearchValue] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(4);
    const [show, setShow] = useState(false);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [refresh, setRefresh] = useState(false);

    const handleChangePage = (page) => {
        setCurrentPage(page);
    }

    const fetchData = (search) => {
        setLoading(true);
        Api.get(`/api/custom_dashboard?search=${search}&page=${currentPage}`)
            .then(result => {
                if (result.data.code == 0) {
                    setData(result.data.data);
                } else {
                    toast.error("Lỗi lấy dữ liệu !!");
                }
                setLoading(false)
            });
    };

    useEffect(() => {
        fetchData("");
    }, []);

    useEffect(() => {
        fetchData(searchValue);
    }, [searchTerm, currentPage]);


    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            setSearchTerm(!searchTerm);
        }
    };

    const data_final = (data && data.length > 0) ? data.map(item => ({
        name: { value: item.name },
        permission: { value: "Owner" },
        last_updated: { value: item.last_update },
        created_by: { value: "hieutt@funtap.vn" },
        action: { value: <i className="fa fa-trash"></i> }
    })) : [];

    return (
        <>
            <section className="main__filter">
                <div className="filter">
                    <div className="container-fluid">
                        <form action="" method="get" id="form">
                            <div className="row d-flex flex-row-reverse">
                                <div className="col-md-2">
                                    <div className="form-group" style={{marginBottom: "0"}}>
                                        <div className="filter-sticky">
                                            <div className="d-flex justify-content-end">
                                                <button type="button" onClick={() => setShow(true)} className="btn btn-primary">Create Dashboard</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <section className="main__content">
                <div className="container-fluid">
                    <div className="detail-body">
                        <div className="overview_content pd-20">
                            <div className="mb-4">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="title-head-box">
                                            <p className="title-block">Custom Dashboard</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-4">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="box box--chart mb-4">
                                            <div className="box__content custom-table">
                                                <div className="searchForm col-md-3 mt-2">
                                                    <div className="form-group m-0">
                                                        <div className="form-line">
                                                            <input
                                                                type="text"
                                                                className="form-control input-form-control"
                                                                name="search"
                                                                value={searchValue}
                                                                onChange={(e) => setSearchValue(e.target.value)}
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="Search"
                                                                autoComplete="off"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <LoadingComponent loading={loading} />
                                                <div className="table-responsive">
                                                    <TableComponent
                                                        column={[{
                                                            key : 'name',
                                                            name : 'Name',
                                                        },{
                                                            key : 'permission',
                                                            name : 'Permission',
                                                        },{
                                                            key : 'last_updated',
                                                            name : 'Last updated',
                                                        },{
                                                            key : 'created_by',
                                                            name : 'Created By',
                                                        },{
                                                            key : 'action',
                                                            name : 'Action',
                                                        }]}
                                                        data={data_final}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <PaginationComponent
                                            current={currentPage}
                                            total={totalPage}
                                            handleChangePage={handleChangePage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Modal show={show} onHide={() => setShow(false)}>
                        <Modal.Header>
                            <h5 className="modal-title">Modal title</h5>
                            <button type="button" className="close" onClick={() => setShow(false)}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </Modal.Header>
                        <Modal.Body>
                            <p>URL  to your app on App Store / PlayStore</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary" onClick={() => setShow(false)}>
                                Close
                            </button>
                            <button type="button" className="btn btn-primary">Save changes</button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </section>
        </>
    );
}

export default CustomDashboard;
